// Thai land measurement units
export const THAI_LAND_UNITS = {
  rai: {
    name: 'ไร่',
    nameEn: 'Rai',
    toSquareMeters: 1600,
    toNgan: 4,
    toWa: 400
  },
  ngan: {
    name: 'งาน',
    nameEn: 'Ngan',
    toSquareMeters: 400,
    toRai: 0.25,
    toWa: 100
  },
  wa: {
    name: 'วา',
    nameEn: 'Wa',
    toSquareMeters: 4,
    toRai: 0.0025,
    toNgan: 0.01
  },
  hectare: {
    name: 'เฮกตาร์',
    nameEn: 'Hectare',
    toSquareMeters: 10000,
    toRai: 6.25,
    toNgan: 25,
    toWa: 2500
  }
}

export function useLandUnits() {
  const convertLandUnit = (value, fromUnit, toUnit) => {
    const fromMultiplier = THAI_LAND_UNITS[fromUnit]?.toSquareMeters || 1
    const toMultiplier = THAI_LAND_UNITS[toUnit]?.toSquareMeters || 1
    
    const valueInSquareMeters = value * fromMultiplier
    return valueInSquareMeters / toMultiplier
  }

  const formatLandArea = (value, unit, language = 'th') => {
    const unitInfo = THAI_LAND_UNITS[unit]
    if (!unitInfo) return `${value} ${unit}`
    
    const unitName = language === 'th' ? unitInfo.name : unitInfo.nameEn
    return `${value.toLocaleString()} ${unitName}`
  }

  const getThaiLandOptions = () => {
    return Object.keys(THAI_LAND_UNITS).map(key => ({
      value: key,
      label: THAI_LAND_UNITS[key].name,
      labelEn: THAI_LAND_UNITS[key].nameEn
    }))
  }

  const calculateDosagePerRai = (totalDosage, totalArea, areaUnit) => {
    const areaInRai = convertLandUnit(totalArea, areaUnit, 'rai')
    return areaInRai > 0 ? totalDosage / areaInRai : 0
  }

  return {
    THAI_LAND_UNITS,
    convertLandUnit,
    formatLandArea,
    getThaiLandOptions,
    calculateDosagePerRai
  }
}